import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { ImpersonationBannerComponent } from './impersonation-banner/impersonation-banner.component';
import { ImpersonationConfirmDialogComponent } from './impersonation-confirm-dialog/impersonation-confirm-dialog.component';
import { ImpersonateButtonComponent } from './impersonate-button/impersonate-button.component';

@NgModule({
  declarations: [
    ImpersonationBannerComponent,
    ImpersonationConfirmDialogComponent,
    ImpersonateButtonComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatSnackBarModule,
  ],
  exports: [
    ImpersonationBannerComponent,
    ImpersonateButtonComponent,
    ImpersonationConfirmDialogComponent,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class ImpersonationComponentsModule {}
